import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import queryString from "query-string";
import TeslaIcon from "../icons/TeslaIcon";
import TeslaImg from "../images/tesla.png";
import ShareModalFireworksIcon from "../icons/ShareModalFireworksIcon";
import WhatsAppIcon from "../images/scoial/icon_WhatsApp@2x.png";
import SmsIcon from "../images/scoial/icon_sms.png";
import MessagerIcon from "../images/scoial/icon_messager.png";
import MobileDetectUtil from "../utils/MobileDetectUtil";
import * as orderActionCreator from "../actions/orderActionCreator";
import * as fbEventActionCreator from "../actions/fbEventActionCreator";
import { Progress } from "reactstrap";
import LocalStorageUtil from "../utils/LocalStorageUtil";
import * as FBUtil from "../utils/FbUtil";
import StoreStateConstants from "../constants/store/StoreStateConstants";
import CookieUtil from "../utils/CookieUtil";
import XIcon from "../icons/XIcon";
import FireworksBackgroundImg from "../images/sahua.gif";
import RdsBackIcon from "../icons/RdsBackIcon";
import { sendCustomEvent } from "../apis/ConfigAPI";
import { generateRandomString } from "../utils/RandomGeneratorUtils";

const HTTP_REQUEST_URL = window.location.protocol + "//" + window.location.host + "/?ad=share";
class SuccessfullyPage extends Component {
	constructor(props, context) {
		super(props, context);
		const invitation_text = `Tesla one year free test drive rights! Enjoy an unlimited electric driving experience, apply now!`;
		const cacheClickNum = CookieUtil.loadClickNum();
		const cacheShareProgress = CookieUtil.loadShareProgress();
		this.state = {
			state: -1,
			email: "",
			phone: "",
			successfullyText: "",
			failedText: "",
			navList: [
				{
					title: "Sms",
					img: SmsIcon,
					url: `sms:${MobileDetectUtil.judgeClient() === "iOS" ? "&" : "?"}body=${invitation_text} ${HTTP_REQUEST_URL}`,
					isClick: false,
				},
				{
					title: "WhatsApp",
					img: WhatsAppIcon,
					url: "https://wa.me/?text=" + encodeURIComponent(invitation_text + " " + HTTP_REQUEST_URL),
					isClick: false,
				},
				{
					title: "Messenger",
					img: MessagerIcon,
					url: ["iOS", "Android"].includes(MobileDetectUtil.judgeClient()) ? "fb-messenger://share/?link=" + encodeURIComponent(HTTP_REQUEST_URL) : "https://www.messenger.com/",
					isClick: false,
				},
			],
			clickNum: cacheClickNum,
			progress: cacheShareProgress,
			showShareWarningDialog: false,
			showShareSuccessDialog: false,
			warningMessage: "",
		};
		this.goBack = this.goBack.bind(this);
		this.shareLinkToApp = this.shareLinkToApp.bind(this);
		this.updateOrderStatus = this.updateOrderStatus.bind(this);
		this.toggleShareWarningDialog = this.toggleShareWarningDialog.bind(this);
		this.toggleShareSuccessModal = this.toggleShareSuccessModal.bind(this);
		this.shareSuccessEvent = this.shareSuccessEvent.bind(this);
		this.sendPurchaseEvent = this.sendPurchaseEvent.bind(this);
	}

	componentDidMount() {
		const cacheShareProgress = CookieUtil.loadShareProgress();
		if (cacheShareProgress === 5) {
			this.shareSuccessEvent();
		}

		this.updateOrderStatus();

		const { location } = this.props;
		const queryParams = queryString.parse(location.search);

		let successfullyText = "";
		if (queryParams.origin === "payment") {
			successfullyText = "Thank you for your order! To track the status of your order, we will send an email to %email. At the same time, we will send a text message to your phone number %phone within 5 business days, so be sure to reply.";
		} else {
			successfullyText = "Thank you for submitting! To track the status of your submission, we will send an email to %email. At the same time, we will send a text message to your phone number %phone within 5 business days, so be sure to respond.";
		}
		let failedText = "";
		if (queryParams.origin === "payment") {
			failedText = "Fail to pay! Try again later.";
		} else {
			failedText = "Payment failed. Please try again later!";
		}
		successfullyText = successfullyText.replace("%email", `<span class="tw-text-normal-blue">${queryParams.email}</span>`).replace("%phone", `<span class="tw-text-normal-blue">${queryParams.phone}</span>`);
		this.setState({
			state: parseInt(queryParams.state),
			email: queryParams.email,
			phone: queryParams.phone,
			successfullyText,
			failedText,
		});
	}

	updateOrderStatus() {
		const { orderActions, location } = this.props;
		const queryParams = queryString.parse(location.search);
		const { cSiteUrl, paymentIntentId, subscriptionId, origin, orderNo } = queryParams;

		if (origin === "payment") {
			const orderInfo = LocalStorageUtil.loadOrderDetail();

			if (!orderInfo.email && orderNo && orderNo.trim() !== "") {
				// 调用接口根据订单编号获取订单信息
				orderActions &&
					orderActions
						.getOrderDetailByOrderNo(orderNo)
						.then((data) => {
							const orderData = JSON.parse(data.data);
							this.sendPurchaseEvent(orderData);
						})
						.catch(() => {});
			} else {
				this.sendPurchaseEvent(orderInfo);
			}
		}

		if (origin === "payment" && paymentIntentId && cSiteUrl && subscriptionId) {
			orderActions &&
				orderActions
					.updateOrderStatus({
						payment_intent_id: paymentIntentId,
						status: "succeeded",
						c_site_url: cSiteUrl,
						subscriptionId: subscriptionId,
						curcrency: 2,
					})
					.then((res) => {
						LocalStorageUtil.clearStripePaymentIntent();
						LocalStorageUtil.clearOrderId();
						LocalStorageUtil.clearOrderNumber();
					})
					.catch((err) => console.error(err));

			setTimeout(() => {
				LocalStorageUtil.clearStripePaymentIntent();
				LocalStorageUtil.clearOrderId();
				LocalStorageUtil.clearOrderNumber();
			}, 1000);
		}
	}

	sendPurchaseEvent(orderData) {
		let cachedPurchaseNum = LocalStorageUtil.loadPurchaseEventNum();
		if (cachedPurchaseNum && parseInt(cachedPurchaseNum) >= 1) {
			return;
		}
		cachedPurchaseNum = 0;
		LocalStorageUtil.savePurchaseEventNum(cachedPurchaseNum + 1);

		const { location, fbEventActions } = this.props;
		const queryParams = queryString.parse(location.search);

		let { email, phone, firstName, lastName, state, country, zipCode } = orderData;
		const eventId = generateRandomString(10);
		const eventParams = {
			content_ids: "test-driver",
			content_name: "Car test driver",
			content_type: "product",
			contents: [
				{
					id: "test-driver",
					title: orderData.vehicleModel && orderData.vehicleModel.trim() !== "" ? orderData.vehicleModel : "Model 3",
					quantity: 1,
				},
			],
			currency: "USD",
			num_items: 1,
			value: orderData.insuranceType === StoreStateConstants.PAY_FEE ? 500 : 1050,
		};
		sendCustomEvent("Purchase");
		FBUtil.trackFBEvent("Purchase", eventParams, eventId);
		const userdata = {
			em: email ? email : queryParams.email,
			ph: phone ? phone : queryParams.phone,
			fn: firstName,
			ln: lastName,
			ct: state,
			st: state,
			zp: zipCode,
			country: country,
		};
		fbEventActions && fbEventActions.submitFBConversionEvent("Purchase", eventParams, userdata.em && userdata.em.trim() !== "" ? userdata : null, eventId, LocalStorageUtil.loadOrderId());
		setTimeout(() => {
			LocalStorageUtil.clearStripePaymentIntent();
			LocalStorageUtil.clearOrderId();
			LocalStorageUtil.clearOrderNumber();
		}, 2000);
	}

	goBack() {
		const { history } = this.props;
		history && history.goBack();
	}

	shareSuccessEvent() {
		// 添加分享成功事件
		setTimeout(() => {
			this.toggleShareSuccessModal();
		}, 1000);
	}

	shareLinkToApp(item) {
		sendCustomEvent("ClickTheShareButton");
		let { clickNum, progress } = this.state;
		if (clickNum < 7) {
			clickNum = clickNum + 1;
		}
		if (clickNum === 7) {
			this.shareSuccessEvent();
		}
		if (clickNum === 3) {
			this.setState({ warningMessage: "Share to another friend. No statistics will be performed if you share to the same friend.", showShareWarningDialog: true });
		} else if (clickNum === 5) {
			this.setState({ warningMessage: "Group chats can also be shared.", showShareWarningDialog: true });
		} else {
			if (progress < 5) {
				progress = progress + 1;
			}
		}
		this.setState({ clickNum, progress });
		CookieUtil.saveClickNum(clickNum);
		CookieUtil.saveShareProgress(progress);
		/**
         * 明天裂变的页面要加功能
           分享第一次 进度条20%
           分享第二次 进度条40%
           分享第三次 进度条不变还是40% 出现提示框 请分享给不同的好友，分享给同一个好友不做统计（別の友人にシェアしてください。同じ友人にシェアしても統計は行われません。）
           分享第四次 进度条60%
           分享第五次 进度条不变还是60% 出现提示 框 也可以分享群聊（グループチャットも共有できる）
           分享第六次  进度条80%
           分享第七次  进度条100%
        */
		window.open(item.url, "_blank"); // 打开新窗口
	}

	toggleShareWarningDialog() {
		this.setState({ showShareWarningDialog: !this.state.showShareWarningDialog });
	}

	toggleShareSuccessModal() {
		this.setState({ showShareSuccessDialog: !this.state.showShareSuccessDialog });
	}

	render() {
		const { state, successfullyText, failedText, navList, progress, warningMessage, showShareWarningDialog, showShareSuccessDialog } = this.state;
		const { location } = this.props;
		const queryParams = queryString.parse(location.search);
		const origin = queryParams.origin;
		const progressPrecent = (progress / 5) * 100;

		const shareSuccessText = "Thank you for sharing! We will expedite the review process, so please be on the lookout for our phone calls and emails!";
		return (
			<div className="tw-w-full tw-h-full gotham-font tw-text-[#393c41]">
				{showShareWarningDialog && (
					<div className="tw-w-full tw-h-full tw-fixed tw-left-0 tw-top-0 tw-bg-[rgba(0,0,0,0.7)] tw-flex tw-items-center tw-justify-center tw-z-[1000]">
						<div className="tw-rounded-[15px] tw-w-[500px] phone:tw-w-[80%] animate__animated animate__bounceInDown tw-bg-white tw-px-[15px] tw-py-[15px]">
							<div className="tw-w-full tw-flex tw-justify-end">
								<XIcon color="#333" onClick={this.toggleShareWarningDialog} />
							</div>
							<div className="tw-mt-[12px] tw-text-center">{warningMessage}</div>
						</div>
					</div>
				)}
				{showShareSuccessDialog && (
					<div className="tw-w-full tw-h-full tw-fixed tw-left-0 tw-top-0 tw-bg-[rgba(0,0,0,0.3)] tw-flex tw-items-center tw-justify-center tw-z-[1000]">
						<img src={FireworksBackgroundImg} alt="background" className="tw-z-[1001] tw-absolute tw-left-[50%] tw-top-[50%] tw-w-full tw-h-[225px] " style={{ transform: "translate(-50%, -80%)" }} />
						<div className="tw-z-[1002] tw-rounded-[15px] tw-w-[500px] phone:tw-w-[75%] animate__animated animate__bounceInDown tw-bg-white tw-px-[15px] tw-py-[15px] tw-relative" style={{ boxShadow: "2px 6px 19px 11px rgba(0,0,0,.125)" }}>
							<ShareModalFireworksIcon size={110} className="tw-absolute tw-left-[-20px] tw-top-[-37px]" style={{ transform: "rotate(342deg)" }} />
							<div className="tw-w-full tw-flex tw-justify-end">
								<XIcon color="#333" onClick={this.toggleShareSuccessModal} />
							</div>
							<div className="tw-text-brand-primary tw-text-[22px] tw-font-bold tw-text-center">Share the success!</div>
							<div className="tw-mt-[12px] tw-text-center" dangerouslySetInnerHTML={{ __html: shareSuccessText }}>
								{}
							</div>
						</div>
					</div>
				)}
				<div className="tw-w-full tw-h-full phone:tw-h-full tw-overflow-scroll">
					<div className="tw-z-[100] tw-w-full tw-h-[80px] phone:tw-h-[60px] tw-flex tw-justify-between">
						<div className="tw-w-1/3 tw-h-full tw-flex tw-items-center tw-pl-[20px]">
							<RdsBackIcon onClick={this.goBack} />
						</div>
						<TeslaIcon size={150} color="#171a20" />
						<div className="tw-w-1/3"></div>
					</div>
					<div className="tw-w-[750px] phone:tw-w-full tw-mx-auto phone:tw-px-[20px] phone:tw-w-full">
						<img src={TeslaImg} alt="product" className="tw-w-[100px] tw-mx-auto tw-mt-[20px]" />
						{(origin === "payment" || origin === "submission") && (
							<React.Fragment>
								{state === 1 && (
									<div className="tw-flex tw-flex-col tw-justify-between tw-items-center">
										<div className="tw-w-full tw-text-[18px] phone:tw-text-[14px] tw-font-[500] tw-text-center  phone:tw-text-left tw-mt-[13px]" dangerouslySetInnerHTML={{ __html: successfullyText }}></div>
									</div>
								)}
								{state === 0 && (
									<div className="tw-flex tw-flex-col tw-justify-between tw-items-center">
										<div className="tw-w-full tw-text-[18px] phone:tw-text-[14px] tw-font-[500] tw-text-light-red tw-text-center  phone:tw-text-left">{failedText}</div>
									</div>
								)}
							</React.Fragment>
						)}

						<div className="tw-w-full tw-mt-[0px]">
							<div className="phone:tw-text-[16px] tw-font-[500] tw-text-center tw-font-bold tw-mt-[20px]">
								<div>Share this campaign with your friends,</div>
								Let's expedite the review process!
							</div>
							<div className="phone:tw-mt-[15px] phone:tw-mb-[15px] tw-mt-[30px] tw-mb-[50px] tw-w-[36%] tw-flex tw-justify-center phone:tw-justify-between  tw-items-center tw-flex-wrap tw-mx-auto">
								{navList.map((item, index) => {
									return (
										<div target="__blank" className="tw-inline-block tw-w-[70px] tw-h-[70px] tw-mr-[20px] phone:tw-mr-0 phone:tw-w-[50px] phone:tw-h-[50px] tw-rounded-full tw-mt-[10px] tw-mr-[10px]" onClick={() => this.shareLinkToApp(item, index)} key={item.title}>
											<img src={item.img} alt="app_icon" className="tw-w-full tw-h-full" />
										</div>
									);
								})}
							</div>
							{progress > 0 && (
								<div className="tw-mt-[30px] tw-w-full tw-h-[20px] tw-bg-[#f7f7f7] tw-relative tw-rounded-[10px] tw-overflow-hidden">
									<Progress className="tw-absolute tw-left-0 tw-top-0 tw-text-white tw-h-full  tw-text-[12px]" animated bar color="success" value={progressPrecent}>{`${progressPrecent}%`}</Progress>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		orderActions: bindActionCreators(orderActionCreator, dispatch),
		fbEventActions: bindActionCreators(fbEventActionCreator, dispatch),
	};
}

export default connect(null, mapDispatchToProps)(SuccessfullyPage);
